module.exports = __webpack_public_path__ + "img/logo_zoom_phone.71f29f1f.svg";